import { makeStyles } from '@material-ui/core'
import Grid from '@mui/material/Grid'
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material'
import {
  getFormControlErrorText,
  isFormControlError,
} from 'src/services/formHelperService'
import CustomDatePicker from 'src/components/BuyPolicy/common/CustomDatePicker'
import { GENDER_LIST, RELATION_TYPES } from 'src/utils/constants/BuyPolicy'
import React from 'react'
import { get } from 'lodash'
import { COLORS } from 'src/utils/Themes/colors'
import { calculateAge } from 'src/utils/commonMethods/buyPolicy'

const LifeMemberDetailsForm = ({ lifeMemberDetailsForm, memberIndex }) => {
  const classes = useStyles()

  const { values } = lifeMemberDetailsForm

  const getFieldValue = (fieldKey) => {
    return get(values, `insuredMembers.${memberIndex}.${fieldKey}`)
  }

  const isFieldError = (fieldKey) => {
    return isFormControlError(
      lifeMemberDetailsForm,
      `insuredMembers.${memberIndex}.${fieldKey}`
    )
  }

  const getFieldErrorText = (fieldKey) => {
    return getFormControlErrorText(
      lifeMemberDetailsForm,
      `insuredMembers.${memberIndex}.${fieldKey}`
    )
  }

  const handleFieldChange = (event) => {
    const { name, value } = event?.target
    lifeMemberDetailsForm.setFieldValue(
      `insuredMembers.${memberIndex}.${name}`,
      value,
      true
    )
  }

  const getSubHeading = () => {
    const relation = values?.insuredMembers?.[memberIndex]?.relation
    return (
      <>
        Insured Member&nbsp;&nbsp;
        <span className={classes.subHeadingRelation}>
          (&nbsp;{RELATION_TYPES?.[relation]}&nbsp;)
        </span>
      </>
    )
  }

  const showNomineeCheckBox = () => {
    const member = values?.insuredMembers?.[memberIndex]

    if (member?.dateOfBirth) {
      return calculateAge(member?.dateOfBirth) >= 18
    } else {
      return member?.age >= 18
    }
  }

  const handleNomineeSelect = (event) => {
    const checked = event?.target?.checked
    lifeMemberDetailsForm.setFieldValue(
      `insuredMembers.${memberIndex}.isNominee`,
      checked,
      true
    )
  }

  return (
    <div className={classes.root}>
      <div className={classes.subHeadingContainer}>
        <span className={classes.subHeading}>{getSubHeading()}</span>
        {showNomineeCheckBox() ? (
          <div className={classes.checkboxContainer}>
            <FormControlLabel
              control={
                <Checkbox
                  id='nomineeCheck'
                  size='small'
                  checked={getFieldValue('isNominee')}
                  onChange={handleNomineeSelect}
                />
              }
              label='Select as my Nominee'
            />
          </div>
        ) : null}
      </div>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6} lg={4}>
          <FormControl fullWidth>
            <TextField
              id='firstName'
              name='firstName'
              type='text'
              placeholder='First Name *'
              required
              value={getFieldValue('firstName')}
              onChange={handleFieldChange}
              onBlur={lifeMemberDetailsForm.handleBlur}
              error={isFieldError('firstName')}
              helperText={getFieldErrorText('firstName')}
              className={classes.inputTextField}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <FormControl fullWidth>
            <TextField
              id='lastName'
              name='lastName'
              type='text'
              placeholder='Last Name *'
              required
              value={getFieldValue('lastName')}
              onChange={handleFieldChange}
              onBlur={lifeMemberDetailsForm.handleBlur}
              error={isFieldError('lastName')}
              helperText={getFieldErrorText('lastName')}
              className={classes.inputTextField}
            ></TextField>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <FormControl fullWidth>
            <CustomDatePicker
              id='dateOfBirth'
              name='dateOfBirth'
              type='date'
              placeholder='Date of birth *'
              value={getFieldValue('dateOfBirth')}
              onChange={handleFieldChange}
              onBlur={lifeMemberDetailsForm.handleBlur}
              error={isFieldError('dateOfBirth')}
              helperText={getFieldErrorText('dateOfBirth')}
              className={classes.inputTextField}
            ></CustomDatePicker>
          </FormControl>
        </Grid>

        {/* <Grid item xs={12} md={6} lg={4}>*/}
        {/*  <FormControl sx={{ width: '100%', margin: 0 }} error={isFieldError('profession')}>*/}
        {/*    <Autocomplete*/}
        {/*      id='profession'*/}
        {/*      name='proposerDetails.profession'*/}
        {/*      value={*/}
        {/*        providerDetails?.occupation.find(*/}
        {/*          (item) => item.value === values.proposerDetails.profession,*/}
        {/*        ) || null*/}
        {/*      }*/}
        {/*      onChange={(event, newValue) => {*/}
        {/*        // handleProposerDetailsChange({*/}
        {/*        //   target: { name: 'profession', value: newValue?.value || '' },*/}
        {/*        // });*/}
        {/*      }}*/}
        {/*      options={providerDetails?.occupation ?? []}*/}
        {/*      getOptionLabel={(option) => option.label}*/}
        {/*      renderInput={(params) => (*/}
        {/*        <TextField*/}
        {/*          {...params}*/}
        {/*          id='profession'*/}
        {/*          name='proposerDetails.profession'*/}
        {/*          placeholder='Occupation'*/}
        {/*          className={classes.inputTextField}*/}
        {/*          sx={{*/}
        {/*            '& .MuiInputBase-root': {*/}
        {/*              '& input': {*/}
        {/*                height: '0.7rem !important',*/}
        {/*                minHeight: 'unset',*/}
        {/*              },*/}
        {/*            },*/}
        {/*            '& .MuiInputAdornment-root': {*/}
        {/*              display: values.proposerDetails.profession ? '' : 'none',*/}
        {/*            },*/}
        {/*          }}*/}
        {/*          endAdornment={*/}
        {/*            values.proposerDetails.profession && (*/}
        {/*              <IconButton*/}
        {/*                id='professionClear'*/}
        {/*                className='clear-button'*/}
        {/*                // onClick={() => handleClear('profession')}*/}
        {/*              >*/}
        {/*                <Clear />*/}
        {/*              </IconButton>*/}
        {/*            )*/}
        {/*          }*/}
        {/*        />*/}
        {/*      )}*/}
        {/*      renderOption={(props, option) => (*/}
        {/*        <MenuItem {...props} key={option.value} value={option}>*/}
        {/*          {option.label}*/}
        {/*        </MenuItem>*/}
        {/*      )}*/}
        {/*      onOpen={() => {*/}
        {/*        removeScroll();*/}
        {/*      }}*/}
        {/*      onClose={() => {*/}
        {/*        addScroll();*/}
        {/*      }}*/}
        {/*    />*/}
        {/*    {isFormControlError(lifeMemberDetailsForm, 'proposerDetails.profession') && (*/}
        {/*      <FormHelperText>*/}
        {/*        {getFormControlErrorText(lifeMemberDetailsForm, 'proposerDetails.profession')}*/}
        {/*      </FormHelperText>*/}
        {/*    )}*/}
        {/*  </FormControl>*/}
        {/* </Grid> future development*/}

        <Grid item xs={12} md={6} lg={4}>
          <FormControl fullWidth>
            <RadioGroup
              row
              id='gender'
              name='gender'
              value={getFieldValue('gender')}
              onChange={handleFieldChange}
              onBlur={lifeMemberDetailsForm.handleBlur}
              error={isFieldError('gender')}
              helperText={getFieldErrorText('gender')}
            >
              {GENDER_LIST?.map((genderListItem) => {
                return (
                  <FormControlLabel
                    key={`gender_${genderListItem?.label}`}
                    value={genderListItem?.enum}
                    control={<Radio />}
                    label={genderListItem?.label}
                    className={classes.genderListField}
                  />
                )
              })}
            </RadioGroup>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6} lg={2}>
          <FormControl fullWidth>
            <TextField
              id='height'
              type='number'
              name='height'
              placeholder='Height *'
              required
              value={getFieldValue('height')}
              onChange={handleFieldChange}
              onBlur={lifeMemberDetailsForm.handleBlur}
              error={isFieldError('height')}
              helperText={getFieldErrorText('height')}
              className={classes.inputTextField}
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>CM</InputAdornment>
                ),
              }}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6} lg={2}>
          <FormControl fullWidth>
            <TextField
              id='weight'
              type='number'
              name='weight'
              placeholder='Weight *'
              required
              value={getFieldValue('weight')}
              onChange={handleFieldChange}
              onBlur={lifeMemberDetailsForm.handleBlur}
              error={isFieldError('weight')}
              helperText={getFieldErrorText('weight')}
              className={classes.inputTextField}
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>KG</InputAdornment>
                ),
              }}
            />
          </FormControl>
        </Grid>
      </Grid>
    </div>
  )
}

export default LifeMemberDetailsForm

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  subHeadingContainer: {
    marginBottom: '15px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  genderListField: {
    '& .MuiFormControlLabel-label': {
      fontSize: '12px',
    },
  },
  subHeading: {
    fontSize: '16px',
    color: '#29AACD',
    fontWeight: '600',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // marginLeft: '20px',
  },
  subHeadingRelation: {
    fontSize: '16px',
    color: COLORS.BLACK,
  },
  inputTextField: {
    borderRadius: '5px !important',
    backgroundColor: 'white !important',
    fontSize: '12px !important',
    fontFamily: 'Roboto !important',
    width: '100%',
    '&  .MuiOutlinedInput-input': {
      height: '0.7rem',
    },
  },
})
